<template>
<div>
    <page-title-bar></page-title-bar>
    <app-section-loader :status="loader"></app-section-loader>
    <v-container fluid grid-list-xl pt-0>
        <v-layout row wrap justify-center>
            <v-flex xs12>
                <app-card>
                    <v-card-title>
                        <h4>BẢNG THÔNG TIN PHÒNG</h4>
                        <v-spacer></v-spacer>
                        <v-layout row justify-end>
                            <v-flex xs12 md4>
                                <v-text-field
                                v-model="search"
                                prepend-icon="search"
                                label="Nhập số phòng cần tìm"
                                single-line
                                hide-details
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6>
                                <v-select
                                    label="Tòa nhà"
                                    :disabled="loading.submit"
                                    v-model="chosen_building"
                                    :items="list_building"
                                    prepend-icon="domain"
                                    required
                                    single-line
                                    hide-details
                                ></v-select>
                            </v-flex>
                        </v-layout>
                        <v-btn @click="showFormTaoPhong = !showFormTaoPhong" color="blue" dark>
                            Tạo Phòng Mới
                        </v-btn>
                        <v-btn @click="exportCSV" color="green" dark class="ml-2">
                            <v-icon left>file_download</v-icon>
                            Xuất Excel
                        </v-btn>
                        <export-csv-button
                            :trigger="export_csv.trigger"
                            :title="export_csv.title"
                            :rows="export_csv.rows"
                        ></export-csv-button>
                    </v-card-title>
                    <v-card>
                        <v-data-table
                            :disable-initial-sort="true"
                            :headers="headers"
                            :items="rooms_filter"
                            :rows-per-page-items="rowPerPage"
                        >
                            <template #items="props">
                                <td class="text-center">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                class="ma-0" v-on="on"
                                                flat icon color="blue"
                                                @click="editRoomPrice(props.item)">
                                                <v-icon class="zmdi zmdi-edit"></v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Chỉnh giá phòng</span>
                                    </v-tooltip>
                                </td>
                                <td v-if="is_admin">
                                    <v-checkbox
                                        v-if="!loading_room.includes(props.item.room_id)"
                                        :label="props.item.has_picture ? 'Có hình' : 'chưa'"
                                        color="primary"
                                        v-model="props.item.has_picture"
                                        hide-details
                                        @change="updateHasPicture(props.item)"
                                    ></v-checkbox>
                                    <v-progress-circular v-else color="primary" indeterminate size="24" class="ml-2"></v-progress-circular>
                                </td>
                                <td class="text-center">{{ props.item.room_id | formatNumber }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.room_price | formatNumber }}</td>
                                <td class="text-center">{{ (props.item.room_price_standard ? props.item.room_price_standard : '-') | formatNumber }}</td>
                                <td class="text-center">{{ props.item.room_code || '-' }}</td>
                                <td class="text-center">{{ props.item.deposit_price | formatNumber }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.electric_price | formatNumber }} / kwh</td>
                                <td class="text-center text-no-wrap">{{ props.item.water_price | formatNumber }} / m3</td>
                                <td class="text-center">{{ props.item.trash_price | formatNumber }}</td>
                                <td class="text-center">{{ props.item.washing_machine_price | formatNumber }}</td>
                                <td class="text-center">
                                    {{ props.item.is_included_air_conditioner
                                        ? 'Trả trước'
                                        : props.item.air_conditioner_price
                                            ? 'Trả sau'
                                            : 'Không xài'
                                    }}
                                </td>
                                <td class="text-center">{{ props.item.air_conditioner_price | formatNumber }}</td>
                                <td class="text-center">{{ props.item.motorbike_price | formatNumber }}</td>
                                <td class="text-center">{{ props.item.bike_price | formatNumber }}</td>
                            </template>
                        </v-data-table>
                    </v-card>
                </app-card>
            </v-flex>
        </v-layout>
    </v-container>
    <v-dialog v-model="showFormTaoPhong" max-width="80%">
        <tao-phong></tao-phong>
    </v-dialog>
    <v-dialog v-model="dialog_edit_room_price" max-width="80%">
        <app-card>
        <h4>Thay đổi giá phòng</h4>
        <p class="fs-14 grey--text">Thay đổi giá phòng
            <span class="v-badge primary">{{ form.room_id }}</span>
        </p>
        <v-form @submit.stop.prevent="submit">
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12 md3>
                        <v-text-field
                            label="Giá Phòng"
                            :disabled="loading.submit"
                            v-model.number="form.new_room_price"
                            :rules="requireText"
                            required
                            min="0"
                            type="number"
                            prepend-icon="attach_money"
                        >
                            <template slot="append">
                                VND
                            </template>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md3>
                        <v-text-field
                            label="Giá Chuẩn"
                            :disabled="loading.submit"
                            v-model.number="form.new_room_price_standard"
                            min="0"
                            type="number"
                            prepend-icon="attach_money"
                        >
                            <template slot="append">
                                VND
                            </template>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md3>
                        <v-text-field
                            label="Mã Phòng"
                            :disabled="loading.submit"
                            v-model="form.room_code"
                            prepend-icon="label"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3>
                        <v-menu
                            :close-on-content-click="false"
                            v-model="menu_date_schedule_apply"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                        >
                            <v-text-field
                                slot="activator"
                                v-model="form.date_schedule_apply"
                                label="Ngày áp dụng thay đổi"
                                :disabled="loading.submit"
                                prepend-icon="event"
                                readonly
                            ></v-text-field>
                            <v-date-picker locale="vi-VI" v-model="form.date_schedule_apply" @input="menu_date_schedule_apply = false" :min="blockEditDate" ></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-select
                            label="Áp dụng"
                            :disabled="loading.submit"
                            v-model="form.is_change_contract"
                            :items="list_is_change_contract"
                            prepend-icon="meeting_room"
                            required
                        ></v-select>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    :loading="loading.submit"
                    :disabled="loading.submit"
                    type="submit"
                    color="primary"
                >
                    Áp dụng
                </v-btn>
            </v-card-actions>
            <!-- <v-btn @click="clear" color="primary">{{$t("message.clear")}}</v-btn> -->
        </v-form>
        </app-card>
    </v-dialog>
</div>
</template>

<script>
import api from "Api";
import TaoPhong from './TaoPhong'
import { list_building } from 'Constants/db-config'
import ExportCsvButton from 'Components/ExportExcel/ExportCsvButton.vue'

export default {
    name: 'ThongTinPhong',
    components: {
        TaoPhong,
        ExportCsvButton
    },
    data() {
        return {
            showFormTaoPhong: false,
            loader: false,
            search:'',
            headers: [
                { text: "Thao tác", align: "center", sortable: false },
                { text: "Số phòng", align: "center", sortable: true, value: "room_id" },
                { text: "Giá phòng cho thuê", align: "center", sortable: true, value: "room_price" },
                { text: "Giá chuẩn", align: "center", sortable: true, value: "room_price_standard" },
                { text: "Mã phòng", align: "center", sortable: true, value: "room_code" },
                { text: "Giá cọc", align: "center", sortable: true, value: "deposit_price" },
                { text: "Giá điện", align: "center", sortable: true, value: "electric_price" },
                { text: "Giá nước", align: "center", sortable: true, value: "water_price" },
                { text: "Giá rác", align: "center", sortable: true, value: "trash_price" },
                { text: "Giá máy giặt", align: "center", sortable: true, value: "washing_machine_price" },
                { text: "Loại máy lạnh", align: "center", sortable: true, value: "is_included_air_conditioner" },
                { text: "Giá máy lạnh", align: "center", sortable: true, value: "air_conditioner_price" },
                { text: "Giá xe máy", align: "center", sortable: true, value: "motorbike_price" },
                { text: "Giá xe đạp", align: "center", sortable: true, value: "bike_price" },
            ],
            list_building: [
                ...list_building,
                {text: 'Tất cả', value: ''},
            ],
            chosen_building: '',
            items: [],
            loading: {
                submit: false
            },
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
            dialog_edit_room_price: false,
            menu_date_schedule_apply: false,
            list_is_change_contract: [
                { text: "Chỉ thay đổi giá phòng khi người mới vào", value: false },
                { text: "Thay đổi giá phòng của phòng đang ở", value: true },
            ],
            form: {
                new_room_price: 0,
                new_room_price_standard: null,
                room_code: '',
                room_id: '',
                date_schedule_apply: new Date().toISOString().substring(0, 10),
                is_change_contract: false,
                note: ''
            },
            requireText: [
                v => !!v || "Vui lòng nhập thông tin này",
            ],
            loading_room: [],
            export_csv: {
                loading: false,
                trigger: false,
                title: "ThongTinPhong",
                rows: []
            },
        };
    },
    created() {
        if (this.is_admin) this.headers.splice(1,0, {
            text: "Hình", align: "center", sortable: true, value: "has_picture"
        })
    },
    computed: {
        rooms(){
            return this.$store.state.app.rooms
        },
        rooms_filter(){
            let search = this.search ? this.search.toUpperCase() : ''
            return this.rooms.filter( room => {
                if ( this.chosen_building === '' || room.building === this.chosen_building ){
                    return room.room_id.includes(search)
                }
                return false
            })
        },
        is_admin(){
            return this.$store.state.auth.role === "admin"
        },
        latestPaymentLog() {
            return this.$store.state.app.latestPaymentLog;
        },
        blockEditDate() {
            return this.$store.state.app.blockEditDate
        }
    },
    methods: {
        editRoomPrice: function (room){
            this.form.new_room_price = room.room_price;
            this.form.new_room_price_standard = room.room_price_standard || null;
            this.form.room_code = room.room_code || '';
            this.form.room_id = room.room_id;
            this.dialog_edit_room_price = true;
        },
        submit: async function (){
            const postData = {
                ...this.form,
                date_schedule_apply: new Date(this.form.date_schedule_apply)
            };
            console.log(postData);
            this.$store.commit("loading", true);
            const data = await api.editRoomPrice(postData);
            this.$store.commit("loading", false);
            console.log(data);
            if ( data.status === 200){
                this.dialog_edit_room_price = false;
                swal.fire("Thành công", "Cập nhật giá phòng thành công", "success");
                this.$store.dispatch('getListRooms')
            } else {
                swal.fire("Lỗi", data.message , "error");
            }
        },
		updateHasPicture: async function (room){
			this.loading_room.push(room.room_id);
            const data = await api.updateReceipt(`/rooms/${room._id}`, { has_picture: room.has_picture });
            const index = this.loading_room.indexOf(room.room_id)
			this.loading_room.splice(index, 1);
			if (data.status == 200){
            } else {
                room.has_picture = !room.has_picture
            }
		},
        exportCSV: function() {
            this.export_csv.rows = this.rooms_filter.map(room => ({
                'Số phòng': room.room_id,
                'Mã phòng': room.room_code || '',
                'Tòa nhà': room.building,
                'Giá phòng': room.room_price,
                'Giá chuẩn': room.room_price_standard ? this.$options.filters.formatNumber(room.room_price_standard) : '',
                'Giá cọc': room.deposit_price,
                'Giá điện': room.electric_price,
                'Giá nước': room.water_price,
                'Giá rác': room.trash_price,
                'Giá máy giặt': room.washing_machine_price,
                'Loại máy lạnh': room.is_included_air_conditioner ? 'Trả trước' : (room.air_conditioner_price ? 'Trả sau' : 'Không xài'),
                'Giá máy lạnh': room.air_conditioner_price || '',
                'Giá xe máy': room.motorbike_price,
                'Giá xe đạp': room.bike_price,
                'Có hình ảnh': room.has_picture ? 'Có' : 'Không',
                'Mô tả hình ảnh': room.picture_description || '',
                'Ngày tạo': new Date(room.createdAt).toLocaleDateString('vi-VN'),
                'Ngày cập nhật': room.updatedAt ? new Date(room.updatedAt).toLocaleDateString('vi-VN') : ''
            }));
            this.export_csv.trigger = !this.export_csv.trigger;
        },
    }
};
</script>
